const routes = [{
  path: '/ultimate/query',
  component: () => import('@/views/ultimate/insurance/query'),
  name: 'ultimate-query',
  meta: {
    title: '保单查询'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/ultimate/insurance.js